module.exports = __webpack_public_path__ + "img/section_receivable.c32e8a4c.png";